import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { currentUser, hasRole } = useAuth();

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" />;
  }

  // If roles are specified, check if user has required role
  if (requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some(role => hasRole(role));
    if (!hasRequiredRole) {
      // User doesn't have required role, redirect to dashboard
      return <Navigate to="/dashboard" />;
    }
  }

  // Check if user has Kitabisa domain
  //   if (!currentUser.email || !currentUser.email.endsWith('@kitabisa.com')) {
  //     // Not a Kitabisa email, redirect to login
  //     return <Navigate to="/login" />;
  //   }

  return children;
};

export default ProtectedRoute;